import React, { useState } from "react";

import Form from "../../common/forms/Form";
import FormInput from "../../common/forms/FormInput";
import RequestCompleteModal from "../../common/settings-modal/RequestCompleteModalBody";
import AgreementCheckBox from "../../common/forms/AgreementCheckBox";

import styles from "./projectdetailsmodal.module.scss";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { ApplicationRequestState } from "./ProjectDetailsModalContainer";
import LoadingSpinner from "../../common/LoadingSpinner";

type Props = {
  projectTitle?: string;
  ownerName: string;
  ownerChatDenial: boolean;
  handleClose: () => void;
  handleSubmit: () => void;
  handleInputChange: (value: string | undefined) => void;
  question?: string;
  requestState: ApplicationRequestState;
};

export const ProjectDetailsModal: React.FC<Props> = ({
  projectTitle,
  ownerName,
  ownerChatDenial,
  handleClose,
  handleSubmit,
  handleInputChange,
  question,
  requestState,
}) => {
  const [isAgreement, setIsAgreement] = useState<boolean>(false);

  return (
    <div className={styles["project-details-module-wrapper"]}>
      <div className={styles["project-details-module"]}>
        {requestState === ApplicationRequestState.Doing ? (
          <LoadingSpinner space={1} />
        ) : requestState === ApplicationRequestState.Waiting ? (
          <>
            <div
              className={styles["project-details-module_head"]}
              onClick={handleClose}
            >
              キャンセル
            </div>
            <Form
              handler={() => {
                if (isAgreement) handleSubmit();
              }}
              className={styles["project-details-module_form"]}
              button_class={
                isAgreement
                  ? styles["project-details-module_form_application-button"]
                  : `${styles["project-details-module_form_application-button"]} ${styles["disabled"]}`
              }
              button_id="1"
              button_text="応募する"
              disabled={!isAgreement}
            >
              <h1 className={styles["project-details-module_form_title"]}>
                プロジェクトに応募
              </h1>
              <div
                className={styles["project-details-module_form_description"]}
              >
                「応募する」ボタンを押すと、 運営に応募情報が送信されます。
                <br />
                応募後の手続きや結果に関してはマイページ、またはメールでご連絡致します。
                <br />
                応募後にプロジェクト作成者とチャットを開始できます。
              </div>
              <div className={styles["project-details-module__info"]}>
                <div className={styles["project-details-module__info-title"]}>
                  プロジェクト情報
                </div>
                <div className={styles["project-details-module__info-name"]}>
                  <FontAwesomeIcon icon={["far", "file-alt"]} />
                  {projectTitle}
                </div>
                <div className={styles["project-details-module__info-owner"]}>
                  <FontAwesomeIcon icon={["fas", "user"]} />
                  {ownerName}
                </div>
                {ownerChatDenial && (
                  <p>
                    このユーザーとは現在チャットはできません。
                    <br />
                    やり取りはSELeCT運営を介して行えます。
                  </p>
                )}
              </div>
              {question ? (
                <>
                  <h2
                    className={styles["project-details-module_form_sub-title"]}
                  >
                    プロジェクト作成者からの質問/確認事項
                  </h2>
                  <FormInput
                    handler={handleInputChange}
                    type="textarea"
                    name="sonic_message"
                    placeholder="回答を入力"
                    label={question}
                    label_class={styles["project-details-module_form_label"]}
                  />
                </>
              ) : null}
              <AgreementCheckBox
                value={isAgreement}
                handler={() => setIsAgreement(!isAgreement)}
              >
                <span>
                  あなたまたはプロジェクト作成者がアカウントを削除した場合、
                  あなたのプロジェクト応募情報も削除されます。
                </span>
              </AgreementCheckBox>
            </Form>
          </>
        ) : requestState === ApplicationRequestState.applicationFailed ? (
          <>
            <div className={styles["project-details-module_failure"]}>
              <p>
                送信に失敗しました。
                <br />
                お手数ですが、再度お試しください。
              </p>
              <button type="button" onClick={handleClose}>
                閉じる
              </button>
            </div>
          </>
        ) : (
          <RequestCompleteModal
            handler={handleClose}
            type="応募"
            chat_partner={ownerName}
            ownerChatDenial={ownerChatDenial}
            createRoomResult={
              requestState !== ApplicationRequestState.chatFailed
            }
          />
        )}
      </div>
    </div>
  );
};

export default ProjectDetailsModal;
